import TitleField from './TitleField'
import DescriptionField from './DescriptionField'

const components = {
  Title: TitleField,
  Description: DescriptionField
}

export default components
